import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChildren,
  ElementRef,
  QueryList,
  OnChanges
} from '@angular/core';
import { ActionPlanModel, ActionPlanItem } from '../../shared/models/index';

@Component({
    selector: 'action-plan-item-detail',
    templateUrl: 'item-detail.component.html',
    standalone: false
})
export class ActionPlanItemDetailComponent implements OnInit, OnChanges {
  @Input() public actionPlan: ActionPlanModel;
  @Input() public actionPlanItem: ActionPlanItem;
  @Input() public processing;
  @Input() public showHelp: boolean;
  @Output() public toggleUpdateStatus: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();
  @Input() query = '';

  public selection: any = {};
  errorMessage: string;

  public loading: Boolean = true;

  public currentIndex = 0;
  public maxIndex = 0;

  public observationKey = '';
  public recommandationKey = '';

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    this.observationKey = '';
    this.recommandationKey = '';
    if (!this.actionPlanItem) {
      return;
    }
    if (this.actionPlanItem.observation?.startsWith('plugins.')) {
      this.observationKey = this.actionPlanItem.observation;
    }
    if (this.actionPlanItem.recommandation?.startsWith('plugins.')) {
      this.recommandationKey = this.actionPlanItem.recommandation;
    }
  }

  public cancel() {
    this.toggleCancel.emit();
  }
}
